import "./BrokerProgram.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Pricing from "./sections/Pricing";
import Leistungen from "./sections/Leistungen";
import Ablauf from "./sections/Ablauf";
import ToolsMarketingMaterial from "./sections/ToolsMarketingMaterial";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import KontaktHinweis from "./sections/KontaktHinweis";
import Footer from "@/reusable_sections/Footer";
export default function BrokerProgramPage() {
  return <div>
      <Header />
      <Hero />
      <Pricing />
      <Leistungen />
      <Ablauf />
      <ToolsMarketingMaterial />
      <FrequentlyAskedQuestions />
      <KontaktHinweis />
      <Footer />
    </div>;
}